import React, { useEffect, useMemo, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Modal,
  Pagination,
  TextField,
  Typography,
} from "@mui/material";
import { Toaster } from "react-hot-toast";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import {
  getAllCustomerProspects,
  getAllDealerProspects,
  getAllProspects,
  remarkProspect,
} from "_controllers/officer";
import { toastMessage } from "utils/toastMessage";
import { useHistory } from "react-router-dom";
import ProspectTable from "./DealerProspectTable";
import CustomerProspectTable from "./CustomerProspectTable";
import { useSelector } from "react-redux";
import TableSkeleton from "_shared/TableSkeleton";
import DocumentPreviewSection from "./DocumentPreviewSection";
import TimelinePreviewSection from "./TimelinePreview";
import JKCDealerTable from "./JKCDealerTable";
import { PageHeader, SectionCard, TablePager } from "_shared/ui";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Main = () => {
  let user = useSelector((state) => state.user);
  const [pageSize, setPageSize] = useState(10);
  const [open, setOpen] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [openTimeline, setOpenTimeline] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleTimelineClose = () => {
    setOpenTimeline(false);
    setProspectId1("");
  };
  const handlePreviewClose = () => setOpenPreview(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [textFieldValue, setTextFieldValue] = useState("");

  const [dealerProspects, setDealerProspects] = useState([]);
  const [customerProspects, setCustomerProspects] = useState([]);
  const [prospectInfo, setProspectInfo] = useState({});

  const [prospect, setProspect] = useState(true);
  const [customer, setCustomer] = useState(false);
  const [jkcDealer, setJkcDealer] = useState(false);
  const [prospectId, setProspectId] = useState("");
  const [prospectId1, setProspectId1] = useState("");
  const [prospectType, setProspectType] = useState("");

  const [totalPagesDealer, setTotalPagesDealer] = useState(1);
  const [totalPagesCustomer, setTotalPagesCustomer] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [reload, setReload] = useState("");
  const handleTextFieldChange = (event) => {
    setTextFieldValue(event.target.value);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    // Use the textFieldValue as needed, e.g., send it to an API, perform an action, etc.
    console.log("TextField Value:", textFieldValue, prospectId, prospectType);
    await remarkProspect(prospectId, prospectType, textFieldValue)
      .then((d) => {
        console.log("data", d);
        setReload(prospectId);
        toastMessage(d?.data?.message, "success");
      })
      .catch((err) => {
        console.log("err", err);
        // setLoading(false);
        toastMessage("error fetching data", "error");
      });
    setOpen(false);
    setTextFieldValue("");
  };

  // Per-tab column sets. Each list must stay in sync with the cells its table
  // actually renders (DealerProspectTable / CustomerProspectTable).
  const dealerColumns = useMemo(
    () => [
      { headerName: "SAP ID", flex: 1 },
      { headerName: "Business Name", flex: 1 },
      { headerName: "Email", flex: 1 },
      { headerName: "Business Phone", flex: 2 },
      { headerName: "Phone", flex: 1 },
      { headerName: "Details", flex: 1 },
      { headerName: "Approval Status", flex: 1 },
      { headerName: "Send for Approval", flex: 1 },
      { headerName: "Financial Profile", flex: 1 },
      { headerName: "Send for E-contracting", flex: 1 },
      { headerName: "Timeline", flex: 1 },
      { headerName: "Onboard Dealer", flex: 1 },
      { headerName: "Sales Admin Approval", flex: 1 },
      { headerName: "Final Approval", flex: 1 },
      { headerName: "Payment Status", flex: 1 },
      { headerName: "SAP Status", flex: 1 },
    ],
    []
  );

  const customerColumns = useMemo(
    () => [
      { headerName: "SAP ID", flex: 1 },
      { headerName: "Business Name", flex: 1 },
      { headerName: "Email", flex: 1 },
      { headerName: "Business Phone", flex: 2 },
      { headerName: "Phone", flex: 1 },
      { headerName: "Details", flex: 1 },
      { headerName: "Approval Status", flex: 1 },
      { headerName: "Send for Approval", flex: 1 },
      { headerName: "Financial Profile", flex: 1 },
      { headerName: "Send for E-contracting", flex: 1 },
      { headerName: "Timeline", flex: 1 },
    ],
    []
  );

  // JKCDealerTable renders its own header row; this list only shapes the
  // loading skeleton for that tab.
  const jkcColumns = useMemo(
    () => [
      { headerName: "Dealer Code", flex: 1 },
      { headerName: "Name", flex: 1 },
      { headerName: "Email", flex: 1 },
      { headerName: "Phone", flex: 2 },
      { headerName: "Generate Financial Score", flex: 1 },
      { headerName: "Financial Profile", flex: 1 },
      { headerName: "Timeline", flex: 1 },
    ],
    []
  );
  let timerId;

  // const handleChange = (e) => {
  //   const { value } = e.target;
  //   clearTimeout(timerId);
  //   timerId = setTimeout(() => {
  //     setSearch(value);
  //   }, 500);
  // };

  useEffect(() => {
    let timerId;
    const debounceDelay = 1000;
    const fetchDealerProspectsWithDebounce = async () => {
      setLoading(true);
      try {
        const d = await getAllDealerProspects({ currentPage, search });
        console.log("Dealer prospects API response:", d);
        setDealerProspects(
          d?.dealerProspects?.map((item) => ({
            ...item,
            prosStatus: { ...item?.prosStatus },
          }))
        );
        setTotalPagesDealer(d?.totalPageDealer);
        setLoading(false);
      } catch (err) {
        console.log("err", err);
        setLoading(false);
        toastMessage("error fetching data", "error");
      }
    };
    timerId = setTimeout(fetchDealerProspectsWithDebounce, debounceDelay);
    return () => clearTimeout(timerId);
  }, [search, currentPage, reload]);

  useEffect(() => {
    let timerId;
    const debounceDelay = 1000;
    const fetchCustomerProspectsWithDebounce = async () => {
      setLoading(true);
      try {
        const d = await getAllCustomerProspects({ currentPage, search });
        setCustomerProspects(
          d?.customerProspects?.map((item) => ({
            ...item,
            prosStatus: { ...item?.prosStatus },
          }))
        );
        setTotalPagesCustomer(d?.totalPageCustomer);
        setLoading(false);
      } catch (err) {
        console.log("err", err);
        setLoading(false);
        toastMessage("error fetching data", "error");
      }
    };
    timerId = setTimeout(fetchCustomerProspectsWithDebounce, debounceDelay);
    return () => clearTimeout(timerId);
  }, [search, currentPage, reload]);

  const handleChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  // useEffect(async () => {
  //   await getAllCustomerProspects({ currentPage, search })
  //     .then((d) => {
  //       // setDealerProspects(
  //       //   d?.dealerProspects?.map((item) => ({
  //       //     ...item,
  //       //     prosStatus: { ...item?.prosStatus },
  //       //   }))
  //       // );
  //       setCustomerProspects(
  //         d?.customerProspects?.map((item) => ({
  //           ...item,
  //           prosStatus: { ...item?.prosStatus },
  //         }))
  //       );
  //       // setTotalPagesDealer(d?.totalPageDealer);
  //       setTotalPagesCustomer(d?.totalPageCustomer);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log("err", err);
  //       setLoading(false);
  //       toastMessage("error fetching data", "error");
  //     });
  // }, [reload, currentPage, search]);

  const remarkAction = async (popupState, prospect) => {
    setOpen(!open);
    setProspectId(prospect.prospect_id);
    setProspectType(prospect.prospectType);
    popupState.close();
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        pr: 2,
      }}
    >
      {prospectInfo?.documentLinks ? (
        <DocumentPreviewSection
          openPreview={openPreview}
          handlePreviewClose={handlePreviewClose}
          prospectInfo={prospectInfo}
        />
      ) : (
        ""
      )}
      {prospectId1 == "" ? (
        ""
      ) : (
        <TimelinePreviewSection
          openTimeline={openTimeline}
          handleTimelineClose={handleTimelineClose}
          prospectId1={prospectId1}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              "& > :not(style)": { m: 1, width: "25ch" },
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="standard-basic"
              label="Remark"
              variant="standard"
              value={textFieldValue}
              onChange={handleTextFieldChange}
            />
            <Button type="submit" size="small" variant="contained">
              Add Remark
            </Button>
          </Box>
        </Box>
      </Modal>
      <Box sx={{ flexShrink: 0 }}>
        <PageHeader
          title="Actyv E-Contract Prospects"
          subtitle="Review and progress dealer & customer prospects through e-contracting"
        />
      </Box>
      <SectionCard
        sx={{ flexShrink: 0, mb: 2 }}
        contentSx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <TextField
          size="small"
          onChange={handleChange}
          value={search}
          name="search"
          variant="outlined"
          label="search by name, email, phone & SO_ID"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
          <Button
            onClick={() => {
              setProspect(true);
              setCustomer(false);
              setJkcDealer(false);
              setSearch("");
            }}
            variant={prospect ? "contained" : "outlined"}
          >
            Dealer Prospects
          </Button>
          <Button
            onClick={() => {
              setProspect(false);
              setCustomer(true);
              setJkcDealer(false);
              setSearch("");
            }}
            variant={customer ? "contained" : "outlined"}
          >
            Customer Prospects
          </Button>
          <Button
            onClick={() => {
              setProspect(false);
              setCustomer(false);
              setJkcDealer(true);
              setSearch("");
            }}
            variant={jkcDealer ? "contained" : "outlined"}
          >
            JKC Dealers
          </Button>
        </Box>
      </SectionCard>
      <Box
        sx={{
          width: "98%",
          mt: "1rem",
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading ? (
          <TableSkeleton
            columns={
              prospect ? dealerColumns : customer ? customerColumns : jkcColumns
            }
            rows={pageSize}
            height="100%"
          />
        ) : prospect ? (
          <>
            <Box sx={{ flex: 1, minHeight: 0, display: "flex" }}>
              <ProspectTable
                data={dealerProspects}
                header={dealerColumns}
                setReload={setReload}
                remarkAction={remarkAction}
                openPreview={openPreview}
                setOpenPreview={setOpenPreview}
                setProspectInfo={setProspectInfo}
                prospectInfo={prospectInfo}
                openTimeline={openTimeline}
                setOpenTimeline={setOpenTimeline}
                setProspectId1={setProspectId1}
              />
            </Box>
            <TablePager
              totalPages={totalPagesDealer}
              page={currentPage}
              rowsPerPage={10}
              onPageChange={(p) => handlePageChange(null, p)}
            />
          </>
        ) : customer ? (
          <>
            <Box sx={{ flex: 1, minHeight: 0, display: "flex" }}>
              <CustomerProspectTable
                data={customerProspects}
                header={customerColumns}
                setReload={setReload}
                remarkAction={remarkAction}
                openPreview={openPreview}
                setOpenPreview={setOpenPreview}
                setProspectInfo={setProspectInfo}
                prospectInfo={prospectInfo}
                openTimeline={openTimeline}
                setOpenTimeline={setOpenTimeline}
                setProspectId1={setProspectId1}
              />
            </Box>
            <TablePager
              totalPages={totalPagesCustomer}
              page={currentPage}
              rowsPerPage={10}
              onPageChange={(p) => handlePageChange(null, p)}
            />
          </>
        ) : jkcDealer ? (
          <>
            <Box sx={{ flex: 1, minHeight: 0, display: "flex" }}>
              <JKCDealerTable
                data={customerProspects}
                header={jkcColumns}
                setReload={setReload}
                remarkAction={remarkAction}
                openPreview={openPreview}
                setOpenPreview={setOpenPreview}
                setProspectInfo={setProspectInfo}
                prospectInfo={prospectInfo}
                openTimeline={openTimeline}
                setOpenTimeline={setOpenTimeline}
                setProspectId1={setProspectId1}
              />
            </Box>
            <TablePager
              totalPages={totalPagesCustomer}
              page={currentPage}
              rowsPerPage={10}
              onPageChange={(p) => handlePageChange(null, p)}
            />
          </>
        ) : null}
      </Box>
      {/* <DataGrid
        rows={search ? searchData : visitData}
        columns={columns1}
        autoHeight={true}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        className="TableCell"
        rowsPerPageOptions={[10, 25, 50, 100]}
        sx={{ fontSize: "0.75rem" }}
        style={{ overflowX: "auto" }}
      /> */}
      <Toaster />
    </Box>
  );
};

const Actyvai = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default Actyvai;
